import { Fab,  Paper, Theme, Typography, withStyles, TableCell, TableRow, Table, TableHead, TableBody, 
    TableFooter, TablePagination, FormControlLabel, TextField, FormControl, InputLabel, Select, MenuItem, useMediaQuery, useTheme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import {motion} from 'framer-motion';
import React, { useGlobal, useDispatch } from 'reactn';
import IForfettariAppBar from '../../appBar/IForfettariAppBar';
import { IGlobalState } from '../../states/GlobalState';
import Auth, { getIdentityFromStorage, getLevels } from '../../types/auth';
import AddIcon from '@material-ui/icons/Add';
import SearchIcon from '@material-ui/icons/Search';
import BlockIcon from '@material-ui/icons/Lock'
import {ClearIcon} from '../../icons/icons';
import '../../css/media-query-styles.css';
import Main from '../../components/main';
import { useLogger } from '../../logger';
import {useHistory} from 'react-router-dom';
import { Principal, PrincipalSearchModel } from '../../models/principal';
import TablePaginationActions from '@material-ui/core/TablePagination/TablePaginationActions';
import { getPrincipals, getPrincipal, getActiveUsers } from '../../services/principalService';
import { Applicazioni } from '../../types/types';
import { globalStyles } from '../../style/GlobalStyles';
import { breakpoint } from '../../types/constants';
import { Agency, AgencySearchModel } from '../../models/agency';
import { getAgencies } from '../../services/agencyService';
import { Roles } from '../../models';
import { filterVariants } from '../../animation/variants';
import { Autocomplete, AutocompleteChangeReason } from '@material-ui/lab';
import { ChangeEvent } from 'react';

const useStyles = makeStyles((theme: Theme) => createStyles({
    tableContainer: {
      width: "100%",
      marginTop: theme.spacing(3),
      overflowX: "auto",
    },
    table: {
      minWidth: 700,
    },
    tablerow: {
      cursor: 'pointer',
    },
    filterContainer: {
        paddingLeft: theme.spacing(2),
        paddingBottom: theme.spacing(0),
        display: 'inline',
    },
    fab: {
        // textAlign: 'left'
    },
    select: {
        width: 168,
        // paddingBottom: 40,
        fontSize: '1rem'
    },
    selectLong: {
        width: 300,
        fontSize: '1rem'
    },
    formControl: {
        minWidth: 150
    }
}));

const CustomBlockIcon = withStyles((theme: Theme) => createStyles({
  root: {
      fontSize: 20,
      color: theme.palette.primary.main,
  },
}))(BlockIcon);
const CustomTableCellForIcon = withStyles((theme: Theme) => createStyles({
  body: {
      fontSize: 20,
      textAlign: 'center',
      color: theme.palette.secondary.main,
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      paddingTop: theme.spacing(0.25),
      paddingBottom: theme.spacing(0),
      borderLeft: 'solid 1px #c0c0c0'
  },
}))(TableCell);
const CustomTableCell = withStyles((theme: Theme) => createStyles({
  head: {
      fontSize: 14,
      // backgroundColor: theme.palette.common.black,
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.common.white,
      paddingLeft: theme.spacing(1),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      borderLeft: 'solid 1px #c0c0c0',
  },
  body: {
      fontSize: 14,
      paddingLeft: theme.spacing(1),
      paddingTop: theme.spacing(0.25),
      paddingBottom: theme.spacing(0.25),
      borderLeft: 'solid 1px #c0c0c0'
  },
}))(TableCell);
const CustomTableRow = withStyles((theme: Theme) => createStyles({
  root: {
      color: "inherit",
      display: "table-row",
      outline: "none",
      verticalAlign: "middle",
      height: 28,
  },
}))(TableRow);

export default function PrincipalIndex() {
    // eslint-disable-next-line
    const theme = useTheme();
    const gClasses = globalStyles();
    const [identity,] = useGlobal<IGlobalState, 'identity'>('identity');
    const [pagination, setPagination] = useGlobal<IGlobalState, 'principalPagination'>('principalPagination');
    const [filteredPrincipals, setFilteredPrincipals] = useGlobal<IGlobalState, 'filteredPrincipals'>('filteredPrincipals');
    const [loadingPrincipals, setLoadingPrincipals] = useGlobal<IGlobalState, 'loadingPrincipals'>('loadingPrincipals');
    const [globalWait, setGlobalWait] = useGlobal<IGlobalState, 'globalWait'>('globalWait');
    const [application, setApplication] = useGlobal<IGlobalState, 'application'>('application');
    const [ip, ] = useGlobal<IGlobalState, 'ip'>('ip');
    const [auth, ] = useGlobal<IGlobalState, 'auth'>('auth');
    const [licenseNumber,] = useGlobal<IGlobalState, 'licenseNumber'>('licenseNumber');
    const logger = useLogger({key: 'Principal'});
    const history = useHistory();
    const dispatch = useDispatch();
    const adLevels = getLevels(auth.authData);
    const classes = useStyles();
    const mobile = useMediaQuery(theme.breakpoints.down(breakpoint));
    const [agenciesForUser, setAgenciesForUser] = React.useState<Agency[]>([]);
    const [agency, setAgency] = React.useState<Agency | null>(null);
    const [usersFilter, setUsersFilter] = useGlobal<IGlobalState, 'usersFilter'>('usersFilter');
    let model: PrincipalSearchModel = new PrincipalSearchModel();
    let modelA: AgencySearchModel = new AgencySearchModel();
    //paginazione lato server
    let direction: string | undefined = mobile ? 'column' : 'row';
    let querySurname: string = ''
    let queryId: number = 0
    let pageDirection: string = 'forward'    
    
    const _handleChangePage = (ev: React.MouseEvent<HTMLButtonElement> | null, page: number) => {
        //debugger;
        setPagination({...pagination, page});
        if (page > pagination.page) {
            pagination.direction = 'forward';
            querySurname = filteredPrincipals && filteredPrincipals.length > 0 ? filteredPrincipals.slice(-1)[0].Surname : '';
            queryId = filteredPrincipals && filteredPrincipals.length > 0 ? filteredPrincipals.slice(-1)[0].Id : 0;
            pageDirection = 'forward';
        }
        else
        {
            pagination.direction = 'back';
            querySurname = filteredPrincipals && filteredPrincipals.length > 0 ? filteredPrincipals[0].Surname : '';
            queryId = filteredPrincipals && filteredPrincipals.length > 0 ? filteredPrincipals[0].Id : 0;
            pageDirection = 'back';
        }
        
        model.QuerySurname = querySurname;
        model.QueryId = queryId;
        model.PageDirection = pageDirection;

        handleSearch();
    }

    const _handleChangeRowsPerPage = (ev: React.ChangeEvent<HTMLTextAreaElement|HTMLInputElement>) => setPagination({...pagination, rowsPerPage: parseInt(ev.target.value)})
    
    const _handleRowClick = (ev: React.MouseEvent<HTMLTableRowElement, MouseEvent>, principal: Principal) => {
        if(globalWait) {return;}
        console.log(`_handleRowClick.${principal.Id}`, {principal})
        pagination.querySurname = querySurname;
        pagination.queryId = queryId;
        setGlobalWait(true);
        getPrincipal(ip, auth.authData!, auth.user!, principal.Id).then((p: Principal)  => {
            if(p) {
                dispatch.setCurrentEditPrincipalAndMode(p, 'Edit');
                history.push(`/principalDetail/${p.Id}`);
            } else {
                // notifyUser(`Company con oid = ${company.Id} non trovata`, 'error')
                logger.error('Errore in recupero Principal non trovata avente id: ' + principal.Id);
            }
        }).finally(() => setGlobalWait(false));
    }

    const handleChangeFilter = (e: any) => {
        let { name, value } = e.target;
        // console.log('Filter username SERIALIZZATO: ' + value);
        setUsersFilter({...usersFilter, username: value});
    }

    const handleChangeFilterName = (e: any) => {
        let { name, value } = e.target;
        setUsersFilter({...usersFilter, name: value});
    }
    
    const handleChangeFilterSurname = (e: any) => {
        let { name, value } = e.target;
        setUsersFilter({...usersFilter, surname: value});
    }
    
    const handleChangeFilterRole = (e: any) => {
        let { name, value } = e.target;
        setUsersFilter({...usersFilter, role: value});
    }
    
    const handleChangeSelectAgency = (event: ChangeEvent<{}>, value: Agency | null, reason: AutocompleteChangeReason) => {
        // let { name, value } = e.target;
        console.log('agency id: ' + value?.Id);
        setAgency(value);
        setUsersFilter({...usersFilter, agencyId: value ? value.Id : null});
    }
    
    const handleClear = () => {
        setAgency(null);
        setUsersFilter({name: '', username: '', surname: '', role: '', agencyId: null});
    }

    const loadAgency = async () => {
        let myAgencies = await getAgencies(ip, auth.authData!, auth.user!, modelA);
        // console.log('recuperate agencies for the user: ' + myAgencies.length); 
        setAgenciesForUser(myAgencies?.ResultList);
    }
    
    const handleAdd = () => {
        console.log('*** +++ handleAdd Principal');
        const newOid = 0;                
        //TODO verificare che utente che inserisce abbia una studio, 
        // l'inserimento va sullo stesso studio, se utente che inserisce non ha lo studio insert bloccata
        setGlobalWait(true);        
        let agencyId: number | null = null; 
        if (identity?.PrincipalAuth && identity?.PrincipalAuth.length > 0) {
            agencyId = identity?.PrincipalAuth[0].AgencyId;
        }
        getActiveUsers(ip, auth.authData!, auth.user!, agencyId!).then((users: Principal[]) => {
            console.log('I principals active for the agency are: ' + users.length);
            if (users && users.length >= licenseNumber && agencyId !== null) {
                logger.error('Non ci sono licenze disponibili per lo studio per attivare un utente');
                return;
            }
            else {
                // setGlobalWait(false);
                dispatch.createNewPrincipal(newOid, identity?.CompanyId);
                history.push(`/principalDetail/${newOid}`);        
            }
        })
        .finally(() => setGlobalWait(false) );
    }
  
    const handleSearch = () => {
        console.log('search principal event');
        setLoadingPrincipals(true);
        model.Username = usersFilter.username;
        model.Name = usersFilter.name;
        model.Surname = usersFilter.surname;
        model.Role = usersFilter.role;
        model.AgencyId = usersFilter.agencyId;
        model.Take = pagination.rowsPerPage;
        if (!model.PageDirection || model.PageDirection === '' ) model.PageDirection = pageDirection
        
        getPrincipals(ip, auth.authData!, auth.user!, model).then(res => {
            console.log('Ritorno le Principal ' + JSON.stringify(res.ResultList));            
            setFilteredPrincipals(res.ResultList as Principal[]);
            if (res.ResultList && res.ResultList.length > 0) {
                pagination.rows = res.ListLength;
            }
        }).catch(error => {
            logger.error('Errore in recupero Principal: ' + error.statusText);
        })
        .finally(() => setLoadingPrincipals(false));
    }

    React.useEffect(() => {
        querySurname = pagination.querySurname
        queryId = pagination.queryId;
        
        setApplication(Applicazioni.Principal);
        loadAgency();
    }, []);


    return (
    <div style={{ backgroundColor: "#e3e3e3", minHeight: "100vh" }}>
      <IForfettariAppBar title="Gestione studi" handleLoad={() => {}} ></IForfettariAppBar>
      <Main>
        <div className={gClasses.rootModel}>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', float: 'left', flex: '0 1 auto'}}>
            <div style={{display: 'flex', flexDirection: direction, justifyContent: 'flex-start', float: 'left', flex: '0 1 auto'}}>
                {/* <UserLoader /> */}
                <motion.div 
                    variants={filterVariants}
                    initial="hidden"
                    animate="visible"
                    style={{ flex: '0 1 auto'}}>
                    <h3>
                        Filtri
                    </h3>
                </motion.div>
                &nbsp;
                <div className={classes.filterContainer}>
                    <FormControl className={classes.formControl}>
                        <Autocomplete
                            className={gClasses.selectLong}
                            value={agency}
                            // inputValue={agency ? agency.Name : ""}
                            // defaultValue={agencies.find(v => v.Name[0])}
                            options={agenciesForUser}
                            getOptionLabel={(option: Agency) => option.Name}
                            onChange={handleChangeSelectAgency}
                            renderInput={(params) => <TextField {...params} label="Studio" />}
                        />
                        {/* <Select 
                            className={classes.selectLong}
                            labelId="labelAgency"
                            id="selectAgency"
                            value={usersFilter.agencyId}
                            onChange={handleChangeFilterAgency}
                            
                        >
                            <MenuItem value=""></MenuItem>
                            {renderDivisionOptions()}
                        </Select> */}
                    </FormControl>                    
                </div>
                <div className={classes.filterContainer}>
                    <TextField onChange={handleChangeFilter} color='primary' label="Username" value={usersFilter.username} 
                        InputLabelProps={{
                            shrink: true,            
                        }}/>
                </div>
                <div className={classes.filterContainer}>
                    <TextField onChange={handleChangeFilterName} color='primary' label="Nome" value={usersFilter.name} 
                        InputLabelProps={{
                            shrink: true,            
                        }}/>
                </div>
                <div className={classes.filterContainer}>
                    <FormControl style={{ minWidth: '150px'}}>
                        <TextField onChange={handleChangeFilterSurname} color='primary' label='Cognome' value={usersFilter.surname}
                        InputLabelProps={{
                            shrink: true,            
                        }}/>
                    </FormControl>
                </div>
                <div className={classes.filterContainer}>
                    <InputLabel style={{fontSize: '0.71rem'}}>Ruolo</InputLabel>
                    <FormControl className={classes.formControl} style={{marginTop: '4px'}}>
                        <Select 
                            className={classes.select}
                            labelId="labelUserRole"
                            id="selectUserRole"
                            value={usersFilter.role}
                            onChange={handleChangeFilterRole}
                        >
                            <MenuItem value="SUPERADMIN">SUPERADMIN</MenuItem>
                            <MenuItem value="ADMIN">ADMIN</MenuItem>
                            <MenuItem value="MANAGER">MANAGER</MenuItem>
                            <MenuItem value="OPERATOR">OPERATOR</MenuItem>
                            <MenuItem value="DEMO">DEMO</MenuItem>
                        </Select>
                    </FormControl>                    
                </div>
            </div>
            <div style={{ flex: '1 1 auto' }}></div>
            <motion.div 
                variants={filterVariants}
                initial="hidden"
                animate="visible"
                style={{display: 'flex', flexDirection: direction, justifyContent: 'space-between', float: 'right', flex: '0 1 auto'}}>
                <div style={{ flex: '0 1 auto' }}>
                    <Fab color='default' size='small' className={classes.fab} title="Pulisci"
                        onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => handleClear()}>
                        <ClearIcon />
                    </Fab>
                </div>
                {identity && identity.UserCreation ?
                <>
                &nbsp;
                <div style={{ flex: '0 1 auto' }}>
                    {/* <div style={{ flex: '1 1' }}>&nbsp;</div> */}
                    {/* <div style={{ flex: '0 0' }}>
                    </div> */}
                    <Fab color='default' size='small' className={classes.fab} onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => handleAdd()}>
                        <AddIcon titleAccess="Aggiungi utente"/>
                    </Fab>
                </div>
                </>
                : null
                }
                &nbsp;
                <div style={{ flex: '0 1 auto' }}>
                    <Fab color='default' size='small' className={classes.fab} onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
                            pageDirection = 'forward'
                            querySurname = '';
                            queryId = 0;
                            pagination.page = 0
                            handleSearch()
                    }}
                    >
                        <SearchIcon titleAccess="Ricerca"/>
                    </Fab>
                </div>
            </motion.div>
            </div>
            <Paper className={classes.tableContainer}>
                <Table className={classes.table} size='small'>
                    <TableHead>
                      <TableRow>
                          <CustomTableCell>&nbsp;</CustomTableCell>
                          <CustomTableCell>Id</CustomTableCell>
                          <CustomTableCell>Cognome</CustomTableCell>
                          <CustomTableCell>Nome</CustomTableCell>
                          <CustomTableCell>Studio</CustomTableCell>
                          <CustomTableCell>UserName</CustomTableCell>
                          <CustomTableCell>Mail</CustomTableCell>
                          <CustomTableCell>Ruolo</CustomTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                    {!loadingPrincipals && filteredPrincipals && filteredPrincipals.length 
                        //? (filteredPrincipals.slice(pagination.page * pagination.rowsPerPage, pagination.page * pagination.rowsPerPage + pagination.rowsPerPage).map(principal => (
                        ? (filteredPrincipals.map(principal => (
                          <TableRow hover={true} key={principal.Id} onClick={(ev: React.MouseEvent<HTMLTableRowElement, MouseEvent>) => _handleRowClick(ev, principal)} className={classes.tablerow}>
                              <CustomTableCellForIcon>
                                  {principal.Disabled !== null && <CustomBlockIcon titleAccess='Utente disabilitato'/>}
                              </CustomTableCellForIcon>
                              <CustomTableCell>{principal.Id}</CustomTableCell>
                              <CustomTableCell>{principal.Surname}</CustomTableCell>
                              <CustomTableCell>{principal.Name}</CustomTableCell>
                              <CustomTableCell>{principal.agencyName}</CustomTableCell>
                              <CustomTableCell>{principal.Username}</CustomTableCell>
                              <CustomTableCell>{principal.Mail}</CustomTableCell>
                              <CustomTableCell>{principal.Role}</CustomTableCell>
                          </TableRow>
                      ))) 
                      : <CustomTableRow>
                          <CustomTableCell colSpan={5}>
                              <Typography variant="h6" color="textSecondary">{loadingPrincipals ? "Caricamento..." : "Nessun dato da visualizzare"}</Typography>
                          </CustomTableCell>
                      </CustomTableRow>}
                  </TableBody>
                  <TableFooter>
                      <CustomTableRow>
                          <CustomTableCell colSpan={6}>
                                <TablePagination
                                    rowsPerPageOptions={[10,20,30, { label: 'All', value: -1 }]}
                                    count={pagination.rows ? pagination.rows : 0}
                                    rowsPerPage={pagination.rowsPerPage}
                                    page={pagination.page}
                                    SelectProps={{
                                      native: true,
                                    }}
                                    onChangePage={_handleChangePage}
                                    onChangeRowsPerPage={_handleChangeRowsPerPage}
                                    //ActionsComponent={TablePaginationActions}
                                    labelRowsPerPage="Righe per pagina"
                                    labelDisplayedRows={({ from, to, count }) => count ? `${from}-${to} di ${count}` : ""}
                                    component='div'
                                    style={{display: 'flex'}}
                                />
                          </CustomTableCell>
                      </CustomTableRow>
                  </TableFooter>
              </Table>
          </Paper>
        </div>
      </Main>
    </div>
  );
}